// Material UI
import { makeStyles } from '@material-ui/styles'
// Consts
import Colors from '../../../../../constants/Colors'

export default makeStyles(theme => ({
  root: {
    backgroundColor: Colors.NEGRONI,
    color: Colors.FLUSH_ORANGE,
  },
}))
